module.exports = __webpack_public_path__ + "img/logo.0bf0ec5b.png";